import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { TextAccent } from '../../../components';
import { Wrapper, Section, ImageWrapper, ImageItemWrapper } from './MobileApp.style';

/**
 * Work/Sesame: Mobile App
 */
const MobileApp = () => {
  const data = useStaticQuery(graphql`
    query {
      mobileAppOneTwo: file(relativePath: { eq: "mobile-app-01-02.png" }) {
        childImageSharp {
          fluid(maxWidth: 730) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobileAppThree: file(relativePath: { eq: "mobile-app-03.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobileAppFour: file(relativePath: { eq: "mobile-app-04.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobileAppFive: file(relativePath: { eq: "mobile-app-05.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobileAppSix: file(relativePath: { eq: "mobile-app-06.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobileAppSeven: file(relativePath: { eq: "mobile-app-07.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobileAppEight: file(relativePath: { eq: "mobile-app-08.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobileAppNine: file(relativePath: { eq: "mobile-app-09.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Wrapper>
      <Section>
        <TextAccent colorKind="light">
          <strong>Leading a mobile team</strong> — I led a cross-functional team to build a mobile app as part of a
          retention initiative supporting our weight loss and other subscription models. Guided the project from idea to
          launch, making sure the app was intuitive, engaging, and helped members stay on track with their health goals.
        </TextAccent>
      </Section>
      <ImageWrapper>
        <ImageItemWrapper isMainImage={true}>
          <Img fluid={data.mobileAppOneTwo.childImageSharp.fluid} loading="eager" alt="Application screenshot" />
        </ImageItemWrapper>
        {['Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'].map((image, index) => (
          <ImageItemWrapper key={index}>
            <Img fluid={data[`mobileApp${image}`].childImageSharp.fluid} loading="eager" alt="Application screenshot" />
          </ImageItemWrapper>
        ))}
      </ImageWrapper>
    </Wrapper>
  );
};

export default MobileApp;
